export default "__VITE_ASSET__e2801ad9__"